import { LogLevel } from '@dora/lumberjack';
import { createAction } from '@reduxjs/toolkit';

export const logActionType = 'dora/log';
const log = createAction<{ level: LogLevel; message: string; context?: any }>(logActionType);

export const logTrace = (message: string, context?: any) =>
    log({ level: LogLevel.Trace, message, context });

export const logDebug = (message: string, context?: any) =>
    log({ level: LogLevel.Debug, message, context });

export const logInfo = (message: string, context?: any) =>
    log({ level: LogLevel.Info, message, context });

export const logWarning = (message: string, context?: any) =>
    log({ level: LogLevel.Warning, message, context });

export const logError = (message: string, context?: any) =>
    log({ level: LogLevel.Error, message, context });

export const logCritical = (message: string, context?: any) =>
    log({ level: LogLevel.Critical, message, context });
